import { withStyles, Tooltip } from "@material-ui/core";

export const StyledTooltip = withStyles({
  tooltip: {
    fontSize: 12
  }
})(Tooltip);
